import { render } from "./EditApplicationPage.vue?vue&type=template&id=4c50490b"
import script from "./EditApplicationPage.vue?vue&type=script&lang=js"
export * from "./EditApplicationPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__